import { FunctionComponent, memo } from "react";

import { IProps } from "./anomaly-date-filter-range-button.types";
import { Button } from "@edgetier/components";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { addMonths, endOfMonth, isSameMonth, startOfMonth, subMonths } from "date-fns";
import "./anomaly-date-filter-range-button.scss";

/**
 * A button to shift the date range limits forward or backward one month.
 * @param props.direction       Whether the clicking the button show move the range forwards or backwards.
 * @param props.dateRangeLimits The minimum and maximum dates that the user can select in the range.
 * @param props.onClick         A callback to handle the new date range run when the button is clicked.
 */
const AnomalyDateFilterRangeButton: FunctionComponent<IProps> = ({ dateRangeLimits, direction, onClick }) => {
    const onButtonClick = () => {
        const dateTransformFunction = direction === "forwards" ? addMonths : subMonths;

        const [firstDate, secondDate] = dateRangeLimits;
        const newDates: [Date, Date] = [
            startOfMonth(dateTransformFunction(firstDate, 1)),
            endOfMonth(dateTransformFunction(secondDate, 1)),
        ];

        onClick(newDates);
    };

    return (
        <Button
            className="anomaly-date-filter-range-button"
            disabled={direction === "forwards" && isSameMonth(new Date(), dateRangeLimits[1])}
            outline
            isIconOnly
            aria-label={direction}
            icon={direction === "forwards" ? faArrowRight : faArrowLeft}
            onClick={onButtonClick}
        />
    );
};

export default memo(AnomalyDateFilterRangeButton);
